import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLasts = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M4.01749 3.67565C4.57541 6.7874 6.53613 8.91879 10 10C13.4639 8.91879 15.4246 6.7874 15.9825 3.67565C16.0156 3.4677 16.0016 3.25529 15.9415 3.05306C15.8814 2.85084 15.7767 2.66362 15.6344 2.50432C15.4922 2.34503 15.3159 2.21744 15.1177 2.13038C14.9195 2.04332 14.7041 1.99884 14.4864 2.00002H5.51362C5.2959 1.99884 5.08051 2.04332 4.88231 2.13038C4.68411 2.21744 4.50781 2.34503 4.36558 2.50432C4.22334 2.66362 4.11857 2.85084 4.05847 3.05306C3.99838 3.25529 3.9844 3.4677 4.01749 3.67565V3.67565Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M5.51351 18C5.29588 18.0011 5.08059 17.9567 4.88246 17.8697C4.68433 17.7827 4.50808 17.6552 4.36587 17.496C4.22365 17.3368 4.11884 17.1497 4.05867 16.9476C3.9985 16.7455 3.9844 16.5332 4.01734 16.3253C4.57527 13.2136 6.53604 11.0822 10 10C13.464 11.0822 15.4247 13.2136 15.9827 16.3253C16.0156 16.5332 16.0015 16.7455 15.9413 16.9476C15.8812 17.1497 15.7764 17.3368 15.6341 17.496C15.4919 17.6552 15.3157 17.7827 15.1175 17.8697C14.9194 17.9567 14.7041 18.0011 14.4865 18H5.51351Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLasts);
export default ForwardRef;
